module.exports = __webpack_public_path__ + "img/Avatar_Male_color.3197ee3b.png";